// extracted by mini-css-extract-plugin
export default {"spinner":"_dJxr","spinnerWrap":"VhK8C"};